import React, {Component} from 'react';
import {InputItem, NavBar, Checkbox, Modal, Radio, Toast, Popover} from 'antd-mobile';
import {getOrderSeat,perfectionUserInfo} from '../../../service/homeService'
import {getOftenList} from "../../../service/memberService";

import "./style.less";
import {connect} from "react-redux";
const Item = Popover.Item;
let infoList = [];
let isSubmit = false;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class PerfectionInfo extends Component {
    constructor(props) {
        super(props);
        if (isSubmit) {
            isSubmit = false;
            props.history.push(`/pay/home`,);
        }
        this.state = {
            selPsgModal:false,
            child:'',
            passenger:'',
            data:[],
            psgData:[],
            seatIndex:'',//当前座位
            psgIndex:'',//已选择的当前常用人
            radioVal:'',
        }
    }
    componentDidMount() {
        Toast.hide();
        if(!isSubmit){
            this.getData();
            this.getOftenList();
        }
    };
    getData(){
        Toast.loading('');
        let params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{id:this.props.match.params.id,}
        };
        getOrderSeat(params).then((res)=>{
            if(res.data.code == '0000'){
                Toast.hide();
                res.data.data.map((res)=>{
                    res.name = '';
                    res.idNum = '';
                    res.phone = '';
                    res.isCommon = false;
                    res.numVisible = false;
                    res.numSelected = '身份证';
                    res.idType = 'idcard';
                    res.value = res.id;
                    infoList.push(res);
                });
                this.setState({data:res.data.data})
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    getOftenList(){
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {pageSize:100, pageNum:1}
        };
        getOftenList(params).then((res) => {
            if (res.data.code === '0000') {
                res.data.data.list.map((res)=>{
                    res.value = res.id;
                    if(res.idType == 'idcard'){
                        res.numSelected = '身份证'
                    }
                    if(res.idType == 'passport'){
                        res.numSelected = '护照'
                    }
                    if(res.idType == 'borderCard'){
                        res.numSelected = '边民证'
                    }
                });
                this.setState({psgData: res.data.data.list,});
            } else {
                Toast.info(res.data.msg,3);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    selPsgClick(res,i){
        // let psgData = this.state.psgData;
        // if(res.id){
        //     this.setState({radioVal:res.value});
        // }
        // this.state.data.map((n)=>{
        //     //判断所有座位是否有选择过联系人(n.id),
        //     if(n.id){
        //         this.state.psgData.map((r,i)=>{
        //             if(n.id === r.id){
        //                 psgData.splice(i,1);
        //                 this.setState({psgIndex:''});
        //             }
        //         })
        //     }
        //     //循环的座位与选择座位一致的情况下，判断当前是否有选择过座位
        //     if(n.pid === res.pid && res.id){
        //         console.log(this.state.psgData1);
        //         this.state.psgData1.map((r)=>{
        //             if(r.id === res.id && r.id === n.id){
        //                 psgData.unshift({
        //                     id:r.id,
        //                     name:r.name,
        //                     sfz:r.sfz,
        //                     phone:r.phone,
        //                     value:r.value,
        //                 })
        //             }
        //         });
        //         this.setState({psgIndex:0});
        //     }
        // });
        // this.setState({selPsgModal:true,seatIndex:i,psgData});
        this.setState({selPsgModal:true,seatIndex:i,radioVal:'',psgIndex:''});
    };
    isChild(e,i){
        this.state.data[i].isChild = e.target.checked;
        this.setState({child:e.target.checked})
    }
    isCommon(e,i){
        this.state.data[i].isCommon = e.target.checked;
        this.setState({passenger:e.target.checked})
    }
    itemChange(res,e,i){
        this.setState({radioVal:res.value,psgIndex:i,});
    }
    selPsg(){
        return(
            <Modal
                className="selPsgModal"
                animationType="slide-up"
                popup
                maskClosable={false}
                visible={this.state.selPsgModal}
                onClose={this.onClose('selPsgModal')}
            >
                <div className="content">
                    <div className="top">
                        <div onClick={this.onClose('selPsgModal')}>取消</div>
                        <div>选择乘客</div>
                        <div onClick={()=>this.selPagOk()}>确定</div>
                    </div>
                    <div className="box">
                        <p>支持上车携带身份证扫描完善</p>
                        {/*<div className="goAdd" onClick={()=>this.props.history.push('/addOftenPsg','perfection')}>
                            <i className="icon iconfont icontianjiala"/>
                            <span>添加常用乘车人</span>
                            <i className="icon iconfont icontiaozhuan"/>
                        </div>*/}
                        <div className="itemBox">
                            {
                                this.state.psgData == "" ?  <div>暂无常用乘车人</div> : (
                                    this.state.psgData.map((res,i) => (
                                        <div className="item"  key={i}>
                                            <Radio  key={i} onChange={(e) => this.itemChange(res,e,i)} checked={this.state.radioVal === res.value}/>
                                            <div className="info">
                                                <span>{res.name}</span>
                                                <div className="">{res.idType == 'idcard' ? "身份证" : res.idType == 'borderCard' ? "边民证" :"护照"}  &nbsp;&nbsp;{res.idNum}</div>
                                            </div>
                                        </div>
                                    )
                                ))
                            }
                        </div>

                    </div>
                </div>
            </Modal>
        )
    }
    onClose = key => () => {
        this.setState({[key]: false, radioVal:'',});
    };
    selPagOk(){
        let seatIndex = this.state.seatIndex;
        let psgIndex = this.state.psgIndex;
        let flag = false;
        if(seatIndex !== '' && psgIndex !== ''){
            this.state.data.map((r)=>{
                if(r.value === this.state.psgData[psgIndex].value && r.value !== this.state.data[seatIndex].value){
                    flag = true;
                }
            });
        }
        if(flag){
            Toast.info("请勿重复选择！",2);
            return
        }

        if(psgIndex === ''){
            Toast.info("请选择常用乘客",2)
        }else{
            this.state.psgData[psgIndex].id = infoList[seatIndex].id;
            infoList[seatIndex].numSelected = this.state.psgData[psgIndex].numSelected;
            Object.assign(infoList[seatIndex], this.state.psgData[psgIndex]);
            this.setState({data:infoList,selPsgModal:false});
        }
        this.setState({data:infoList});
    }
    inpChange=(key,i)=>(value)=>{
        let data = this.state.data;
        data[i][key] = value;
        data[i].value = undefined;
        this.setState({data,radioVal:''});
    };
    submitInfo(){
        for(let i = 0 ;i < this.state.data.length;i++ ){
            if(this.state.data[i].name == null || this.state.data[i].name === "" ) {
                return Toast.info("请填写" + this.state.data[i].seatNum + '号座位的姓名！',1)
            }
            if((this.state.data[i].phone == null || this.state.data[i].phone === "") && this.state.data[i].isChild  == 0) {
                return Toast.info("请填写" + this.state.data[i].seatNum + '号座位的联系电话！',1)
            }
            if((this.state.data[i].idNum == null || this.state.data[i].idNum === "")  && this.state.data[i].isChild  == 0) {
                return Toast.info("请填写" + this.state.data[i].seatNum + '号座位的证件号码！',1)
            }
            if(this.state.data[i].idNum < 5 && this.state.data[i].isChild == 0) {
                return Toast.info("证件号码不能少于5位",1)
            }
            if(this.state.data[i].numSelected == "身份证"){
                this.state.data[i].idType = 'idcard'
            }else if(this.state.data[i].numSelected == "护照"){
                this.state.data[i].idType = 'passport'
            }else if(this.state.data[i].numSelected == "边民证"){
                this.state.data[i].idType = 'borderCard'
            }
            // if(this.state.data[i].isChild){
            //     this.state.data[i].isChild = 1
            // }else{
            //     this.state.data[i].isChild = 0
            // }
            if(this.state.data[i].isCommon){
                this.state.data[i].commonPassenger = 1
            }else{
                this.state.data[i].commonPassenger = 0
            }
        }
        let params = {
            source: 1,
            token:this.props.userInfo.token,
            data:this.state.data,
        };
        Toast.loading('',0);
        perfectionUserInfo(params).then((res)=>{
            if(res.data.code == '0000'){
                isSubmit = true;
                Toast.info("提交成功",this.props.history.push(`/pay/myOrder`,));
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    onSelect = (opt,i) => {
        let data = this.state.data;
        data[i].numVisible = false;
        data[i].numSelected = opt.props.value;
        this.setState({data});
    };
    handleVisibleChange = (visible,i) => {
        let data = this.state.data;
        data[i].numVisible = visible;
        this.setState({data});
    };
    render(){
        return(
            <div className="perfectionInfo">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >完善信息</NavBar>
                <div className="warp">
                    {
                        this.state.data.map((res,i)=>(
                            <div className="box" key={i}>
                                <div className="top">
                                    <span>{res.seatNum}号座位 {res.isChild == 1 ? <span style={{color:"#03B0C6"}}>儿童票</span>:null}</span>
                                    <span className="select" onClick={()=>this.selPsgClick(res,i)}>选择常用乘客</span>
                                </div>
                                <div className="middle">
                                    {/*<Checkbox key={1} onChange={(e) => this.isChild(e,i)}>儿童</Checkbox>*/}
                                    <Checkbox key={2} onChange={(e) => this.isCommon(e,i)}>存为常用乘客</Checkbox>
                                </div>
                                <InputItem
                                    placeholder="请输入姓名"
                                    clear
                                    value={res.name}
                                    onChange={this.inpChange('name',i)}
                                    type="text"
                                ><i className="icon iconfont iconpeople"/></InputItem>
                                <InputItem
                                    placeholder="请输入联系电话"
                                    clear
                                    value={res.phone}
                                    onChange={this.inpChange('phone',i)}
                                    type="number"
                                    maxLength={11}
                                ><i className="icon iconfont iconlianxishouji"/>{res.numVisible}</InputItem>

                                <InputItem
                                    placeholder="请输入证件号"
                                    clear
                                    value={res.idNum}
                                    onChange={this.inpChange('idNum',i)}
                                    maxLength={18}
                                    className="sfz"
                                ><i className="icon iconfont iconshenfenzheng"/>
                                    <Popover mask
                                             placement="left"
                                          overlayClassName="fortest"
                                          visible={res.numVisible}
                                          overlay={[
                                              (<Item key="idcard" value="身份证"  >身份证</Item>),
                                              (<Item key="passport" value="护照" >护照</Item>),
                                              (<Item key="borderCard" value="边民证" >边民证</Item>),
                                          ]}

                                          onVisibleChange={(e)=>this.handleVisibleChange(e,i)}
                                          onSelect={(e)=>this.onSelect(e,i)}
                                    >
                                        <div className="selText">{res.numSelected === undefined ? '身份证' : res.numSelected}<i className="icon iconfont iconxiala"/></div>
                                    </Popover>
                                </InputItem>
                            </div>
                        ))
                    }

                </div>

                <div className="btn" onClick={()=>this.submitInfo()}><button>提交信息</button></div>
                {this.selPsg()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/PerfectionInfo/index.js